import React from 'react';

import {useTranslation} from 'react-i18next';

import {translateUserRole} from 'components/pages/RecallAudit/utils';
import {Select} from 'components/ui-kit/Select';

const roles = [
    'MPL_OPERATOR',
    'MPL_OPERATOR_ADMIN',
    'MPL_MANUFACTURER_DIRECTOR',
    'MPL_IMPORTER_DIRECTOR',
    'MPL_RETAIL_DIRECTOR',
    'MPL_DISTRIBUTOR_DIRECTOR',
];

export const AuditRoleFilter = (props: React.ComponentProps<typeof Select>) => {
    const {t} = useTranslation();
    return (
        <Select
            {...props}
            isClearable
            options={roles.map((value) => ({value, label: translateUserRole(t, 'ROLE_' + value)}))}
        />
    );
};
